let _enabled = false;

export function setLoggerEnabled(enabled) {
    _enabled = Boolean(enabled);
}

export function isLoggerEnabled() {
    return _enabled;
}

export const logger = {
    log: (...args) => { if (_enabled) console.log(...args); },
    warn: (...args) => { if (_enabled) console.warn(...args); },
    error: (...args) => { if (_enabled) console.error(...args); },
    info: (...args) => { if (_enabled) console.info(...args); },
};
